import { call, put, takeLatest } from "redux-saga/effects";
import { syncAzureDataWithVtrack, getSyncDetails } from "../http/requests/settings";
import { toastOptions } from "../common/utils/toasterOptions";
import { toast } from "react-toastify";
import { setSyncDetails,  SettingDataType, setVtrackLoader } from "../redux/actions";


function* workerSyncAzureDataWithVtrack({payload}) {
  try {
    yield put(setVtrackLoader(true));
    yield call(syncAzureDataWithVtrack);
    toast.success("Successfully Synced Data.", toastOptions)
    const syncDetails = yield call (getSyncDetails);
    yield put(setSyncDetails(syncDetails));
    yield put(setVtrackLoader(false));
  } catch (err) {
    console.log(err);
    toast.error(err.data.errorMessage, toastOptions)
    yield put(setVtrackLoader(false));
  }
};

export function* syncAzureDataWithVtrackSaga() {
  yield takeLatest(
    SettingDataType.SYNC_AZURE_DATA_WITH_VTRACK,
    workerSyncAzureDataWithVtrack
  );
};
